/* eslint-disable complexity */
import { min, max } from 'lodash';

const initialState = {
  districtContext: {},
  districtConfiguration: {},
  districtSummary: {},
  studentInfoContext: {},
  courseDetails: {},
  updatedCourseDetails: {},
  programDetails: {},
  programGroups: [],
  programGroupsLoading: false,
  updatedProgramDetails: {},
  selectedStudent: {
    studentId: '',
    studentInfo: {},
    preselectedCourses: [],
    equivalentCredits: [],
    coursePlanningConfig: {},
  },
  studentCount: 0,
  missingInfoCount: 0,
  studentList: [],
  requirementTree: [],
  gradPlanList: [],
  gradPlanDetails: {},
  updatedGradPlanDetails: {},
  studentInfoFilters: {
    searchText: '',
    sortField: 'last_name',
    sortOrder: 'ASC',
    rowsPerPage: 10,
    page: 1,
    missingInfo: false,
  },
  searchCount: 0,
  searchResults: [],
  searchNotVerifiedCount: 0,
  activeFilters: {
    searchText: '',
    sortField: 'courseId',
    sortOrder: 'ASC',
    rowsPerPage: 10,
    page: 1,
    tagsOr: true,
    schoolsOr: true,
    gradesOr: true,
    requestableByStudent: null,
    verified: null,
    droppedOutOfSync: null,
    Subjects: null,
  },
  topLevelRequirement: {},
  updatedProgramSlot: [],
  gradPlanDetailLoading: false,
  searchCourseBusy: false,
  programDetailLoading: false,
  courseDetailLoading: false,
  guidedCourseMasterContext: {},
  requirementTreeLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'POPULATE_DISTRICT_CONFIGURATION':
      return {
        ...state,
        districtConfiguration: action.config,
      };

    case 'POPULATE_DISTRICT_STATUS':
      return {
        ...state,
        districtStatus: action.status,
      };

    case 'POPULATE_DISTRICT_SUMMARY':
      return {
        ...state,
        districtSummary: action.summary,
      };
    case 'SET_UPDATED_PROGRAM_DETAILS': {
      return {
        ...state,
        updatedProgramDetails: {
          ...state.updatedProgramDetails,
          [action.programKey]: action.programValue,
        },
      };
    }
    case 'POPULATE_STUDENT_INFO_CONTEXT':
      return {
        ...state,
        studentInfoContext: action.context,
      };
    case 'POPULATE_DISTRICT_CONTEXT':
      return {
        ...state,
        districtContext: action.context,
      };
    case 'POPULATE_SEARCH_RESULTS':
      return {
        ...state,
        searchResults: action.results.results,
        searchCount: action.results.count,
        searchNotVerifiedCount: action.results.notVerifiedCount,
        searchDroppedOutOfSyncCount: action.results.droppedOutOfSyncCount,
      };
    case 'SET_SEARCH_COURSE_BUSY':
      return {
        ...state,
        searchCourseBusy: action.status,
      };
    case 'POPULATE_STUDENT_SEARCH_RESULTS':
      return {
        ...state,
        studentList: action.students.results,
        studentCount: action.students.count,
        missingInfoCount: action.students.missingCpCount,
      };
    case 'POPULATE_COURSE_DETAILS':
      return {
        ...state,
        courseDetails: action.details,
        updatedCourseDetails: action.details,
      };
    case 'UPDATE_COURSE_DETAILS':
      return {
        ...state,
        updatedCourseDetails: {
          ...state.updatedCourseDetails,
          [action.key]: action.value,
        },
        courseDetails: {
          ...state.courseDetails,
          [action.key]: action.forceUpdateAll
            ? action.value
            : state.courseDetails[action.key],
        },
      };
    case 'ADD_NODE_TO_REQUIREMENTS':
      return {
        ...state,
        requirementTree: [...state.requirementTree, action.requirement],
      };
    case 'POPULATE_TAG_SYMBOL':
      return {
        ...state,
        updatedCourseDetails: {
          ...state.updatedCourseDetails,
          tags:
            state.updatedCourseDetails &&
            state.updatedCourseDetails.tags &&
            state.updatedCourseDetails.tags.length
              ? state.updatedCourseDetails.tags.map(tag => {
                  if (!tag.symbol) {
                    return {
                      ...tag,
                      symbol: action.tag,
                    };
                  }
                  return tag;
                })
              : [
                  {
                    symbol: action.tag,
                  },
                ],
        },
      };
    case 'SET_COLUMN_SORTING': {
      const oppositeDirection =
        state.activeFilters.sortOrder === 'ASC' ? 'DESC' : 'ASC';
      const sortDirection =
        state.activeFilters.sortField === action.column
          ? oppositeDirection
          : state.activeFilters.sortOrder;
      return {
        ...state,
        activeFilters: {
          ...state.activeFilters,
          sortField: action.column,
          sortOrder: sortDirection,
        },
      };
    }
    case 'COURSE_CATALOG.SET_COLUMN_SORTING_DIRECTION': {
      return {
        ...state,
        activeFilters: {
          ...state.activeFilters,
          sortOrder: action.direction,
        },
      };
    }
    case 'SET_STUDENT_INFO_COLUMN_SORTING': {
      const oppositeDirection =
        state.studentInfoFilters.sortOrder === 'ASC' ? 'DESC' : 'ASC';
      const sortDirection =
        state.studentInfoFilters.sortField === action.column
          ? oppositeDirection
          : state.activeFilters.sortOrder;
      return {
        ...state,
        studentInfoFilters: {
          ...state.studentInfoFilters,
          sortField: action.column,
          sortOrder: sortDirection,
        },
      };
    }
    case 'SET_STUDENT_INFO_FILTER': {
      return {
        ...state,
        studentInfoFilters: {
          ...state.studentInfoFilters,
          [action.filterName]: action.filter,
        },
      };
    }
    case 'SET_OPERATOR': {
      return {
        ...state,
        activeFilters: {
          ...state.activeFilters,
          [action.operatorName]: action.operatorType,
        },
      };
    }
    case 'CHANGE_STUDENT_INFO_GRID_PAGE': {
      return {
        ...state,
        studentInfoFilters: {
          ...state.studentInfoFilters,
          page: action.page,
        },
      };
    }
    case 'CHANGE_GRID_PAGE': {
      return {
        ...state,
        activeFilters: {
          ...state.activeFilters,
          page: action.page,
        },
      };
    }
    case 'SET_ACTIVE_FILTER': {
      const valueSelectedAlready =
        state.activeFilters[action.filterName] &&
        Array.isArray(state.activeFilters[action.filterName]) &&
        state.activeFilters[action.filterName].includes(action.filter);
      if (valueSelectedAlready) {
        const updatedActiveFilters = {
          ...state.activeFilters,
          [action.filterName]: state.activeFilters[action.filterName].filter(
            selected => selected !== action.filter,
          ),
        };
        if (action.removeFilter) {
          delete updatedActiveFilters[action.filterName];
        }
        return {
          ...state,
          activeFilters: updatedActiveFilters,
        };
      }
      const priorSelectedValues = state.activeFilters[action.filterName] || [];
      const updatedActiveFilters = {
        ...state.activeFilters,
        [action.filterName]: action.singleFilter
          ? [action.filter]
          : [...priorSelectedValues, action.filter],
      };
      if (action.removeFilter) {
        delete updatedActiveFilters[action.filterName];
      }
      return {
        ...state,
        activeFilters: updatedActiveFilters,
      };
    }
    case 'COURSE_CATALOG.RESET_ACTIVE_FILTER': {
      return {
        ...state,
        activeFilters: {
          ...state.activeFilters,
          ...initialState.activeFilters,
        },
      };
    }
    case 'SET_ACTIVE_STUDENT':
      return {
        ...state,
        selectedStudent: {
          ...state.selectedStudent,
          studentId: action.studentId,
          studentInfo: action.studentInfo,
        },
      };
    case 'SET_ACTIVE_STUDENT_FILTER': {
      const valueSelectedAlready =
        state.studentInfoFilters[action.filterName] &&
        state.studentInfoFilters[action.filterName].includes(action.filter);
      if (valueSelectedAlready) {
        return {
          ...state,
          studentInfoFilters: {
            ...state.studentInfoFilters,
            [action.filterName]: state.studentInfoFilters[
              action.filterName
            ].filter(selected => selected !== action.filter),
          },
        };
      }
      const priorSelectedValues =
        state.studentInfoFilters[action.filterName] || [];
      return {
        ...state,
        studentInfoFilters: {
          ...state.studentInfoFilters,
          [action.filterName]: [...priorSelectedValues, action.filter],
        },
      };
    }
    case 'UPDATE_EDIT_PROGRAM_SLOT':
      return {
        ...state,
        updatedProgramSlot: action.value,
      };
    case 'POPULATE_PROGRAM_GROUPS':
      return {
        ...state,
        programGroups: action.groups,
      };
    case 'POPULATE_PROGRAM_DETAILS':
      return {
        ...state,
        programDetails: action.details,
        updatedProgramDetails: action.details,
      };
    case 'POPULATE_TOP_LEVEL_REQUIREMENT':
      return {
        ...state,
        topLevelRequirement: action.requirement,
      };

    case 'POPULATE_PRESELECTED_COURSES':
      return {
        ...state,
        selectedStudent: {
          ...state.selectedStudent,
          preselectedCourses: action.courses,
        },
      };
    case 'POPULATE_EQUIVALENT_CREDITS':
      return {
        ...state,
        selectedStudent: {
          ...state.selectedStudent,
          equivalentCredits: action.credits,
        },
      };
    case 'POPULATE_STUDENT_CONFIGURATION':
      return {
        ...state,
        selectedStudent: {
          ...state.selectedStudent,
          coursePlanningConfig: action.config,
        },
      };

    case 'POPULATE_GRAD_PLAN_DETAILS':
      return {
        ...state,
        gradPlanDetails: {
          ...action.details,
          gradeMin: min(action.details.grades),
          gradeMax: max(action.details.grades),
        },
        updatedGradPlanDetails: {
          ...action.details,
          gradeMin: min(action.details.grades),
          gradeMax: max(action.details.grades),
        },
      };
    case 'UPDATE_GRAD_PLAN_DETAILS':
      return {
        ...state,
        updatedGradPlanDetails: {
          ...state.updatedGradPlanDetails,
          [action.key]: action.value,
        },
      };

    case 'CLEAN_UPDATED_GRAD_PLAN_DETAILS':
      return {
        ...state,
        updatedGradPlanDetails: {},
      };

    case 'POPULATE_GRAD_PLAN_LIST':
      return {
        ...state,
        gradPlanList: action.list,
      };

    case 'UPDATE_LOADING_GRAD_PLAN_DETAIL_STATUS':
      return {
        ...state,
        gradPlanDetailLoading: action.value,
      };

    case 'COURSE_CATALOG.UPDATE_LOADING_REQUIREMENT_TREE_STATUS':
      return {
        ...state,
        requirementTreeLoading: action.value,
      };

    case 'UPDATE_LOADING_PROGRAM_GROUPS':
      return {
        ...state,
        programGroupsLoading: action.status,
      };

    case 'UPDATE_LOADING_PROGRAM_DETAIL_STATUS':
      return {
        ...state,
        programDetailLoading: action.status,
      };

    case 'COURSE_CATALOG.UPDATE_LOADING_COURSE_DETAIL_STATUS':
      return {
        ...state,
        courseDetailLoading: action.status,
      };

    case 'COURSE_CATALOG.POPULATE_GUIDED_COURSE_MASTER_CONTEXT':
      return {
        ...state,
        guidedCourseMasterContext: action.guidedCourseMasterContext,
      };

    case 'COURSE_CATALOG.POPULATE_PROGRAM_SLOTS':
      return {
        ...state,
        programSlots: action.programSlots,
      };

    default:
      return state;
  }
};
